import { Mapper } from '../base-mapper';
import type { DataExtractionFile, ExtractionFileDetails } from '@/types/entities/DataExtraction';
import type { GetExtractionFilesListResponseDTO } from '@/core/dto/data-extraction/get-files-list';

export class GetExtractionFilesListMapper implements Mapper<DataExtractionFile> {
	constructor(private readonly data: GetExtractionFilesListResponseDTO) {}

	private handleFormartData(): ExtractionFileDetails[] {
		return this.data.rows.map((row) => ({
			id: row.id,
			file_name: row.original_name,
			line: row.line.name,
			workstation: row.workstations.name,
			upload_date: row.createdAt
		}));
	}

	private getSelectedFiles(): string[] {
		const selectedFiles = this.data.rows.filter((row) => row.selected);
		return selectedFiles.map(({ id }) => id);
	}

	toDomain(): DataExtractionFile {
		return {
			total: this.data.total,
			page: this.data.page,
			limit: this.data.limit,
			rows: this.handleFormartData(),
			selected: this.getSelectedFiles()
		};
	}
}
